module.exports = __webpack_public_path__ + "static/razroo-rocket-2703e8131b4cc0a63a327b3805a267ca.svg";